import React from 'react';
import { Link } from 'react-router-dom';

// Unknown marketing paths (routeMeta marks these noindex).
const NotFound = () => (
  <div className="mk-page mk-nf">
    <section className="mk-notfound section">
      <div className="container-xs">
        <div className="section-inner center-content">
          <h1 className="mk-h2">Page not found</h1>
          <p className="mk-body">This page doesn't exist.</p>
          <Link className="mk-textlink" to="/">
            Go to the Keep Me Out home page →
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default NotFound;
